import { Role } from '../../../core/auth/models/role';
import { NavbarItem } from './models/navbar.model';

/**
 * Navigation is split by portal: a route subtree is a portal, and each portal
 * has its own item set. The active set is chosen by AppComponent from the URL.
 * The navbar's role filtering still applies within a set, so finer-grained
 * gating (hiding a sub-item from a lesser role) keeps working.
 *
 * Icons are the design-system menu glyphs (outline + filled "-f1" pair).
 */

// Tenant portal — organization-scoped features. Routes are relative to the
// current organization (the navbar prefixes them with the org name).
export const TENANT_NAV_ITEMS: NavbarItem[] = [
  { label: 'Monitor', route: 'monitoring', isDefault: true, icon: 'icon-menu-monitor1', iconActive: 'icon-menu-monitor-f1' },
  { label: 'Devices', route: 'devices', icon: 'icon-menu-monitor1', iconActive: 'icon-menu-monitor-f1' },
  { label: 'Alerts', route: 'alerts', icon: 'icon-menu-alerts1', iconActive: 'icon-menu-alerts-f1' },
  { label: 'Device Configurations', route: 'device-configurations', icon: 'icon-menu-settings1', iconActive: 'icon-menu-settings-f1' },
  { label: 'Operations', route: 'operations', icon: 'icon-menu-appswidgets1', iconActive: 'icon-menu-appswidgets-f1' },
{ label: 'Content', route: 'content', icon: 'icon-menu-content1', iconActive: 'icon-menu-content-f1' },
  { label: 'Media Library', route: 'files', icon: 'icon-menu-content1', iconActive: 'icon-menu-content-f1' },
  { label: 'Layouts', route: 'layouts', icon: 'icon-menu-layouts1', iconActive: 'icon-menu-layouts-f1' },
  { label: 'Settings', route: 'settings', icon: 'icon-menu-settings1', iconActive: 'icon-menu-settings-f1' },
];

// Admin back-office — not organization-scoped, so routes are root-absolute
// (absolute: true). The whole subtree is SUPER_ADMIN-gated at the route level;
// the per-item roles here are belt-and-suspenders for the nav itself.
export const ADMIN_NAV_ITEMS: NavbarItem[] = [
  { label: 'Tenants', route: 'admin/tenants', absolute: true, roles: [Role.SUPER_ADMIN], icon: 'icon-menu-inspector1', iconActive: 'icon-menu-inspector-f1' },
  { label: 'Users', route: 'admin/users', absolute: true, roles: [Role.SUPER_ADMIN], icon: 'icon-menu-inspector1', iconActive: 'icon-menu-inspector-f1' },
  { label: 'Operation Templates', route: 'admin/operation-templates', absolute: true, roles: [Role.SUPER_ADMIN], icon: 'icon-menu-appswidgets1', iconActive: 'icon-menu-appswidgets-f1' },
  { label: 'Providers', route: 'admin/providers', absolute: true, roles: [Role.SUPER_ADMIN], icon: 'icon-menu-contentproviders1', iconActive: 'icon-menu-contentproviders-f1' },
  { label: 'Software Updates', route: 'admin/software-updates', absolute: true, roles: [Role.SUPER_ADMIN], icon: 'icon-cloud' },
];
